import { Component } from '@angular/core';
import { ClassTransformerHelper } from '../../../helpers/class.transformer.helper';
import { InjectorHelper } from '../../../helpers/injector.helper';
import { WorkflowType } from '../../../models/enums/workflowtype.enum';
import { WorkflowModuleExecuter, WorkflowStatus } from '../../../models/workflow/workflow.model';
import { MailSettingsService } from '../../../services/mailsettings.service';
import { SideNavService } from '../../../services/sidenav.service';
import { WorkflowExitInfo, WorkflowModuleSettingsHelper, WorkflowRegistry } from '../../../services/workflow.service';
import { FormulaWorkflowDialogContent } from '../../workflow.dialog';
import { WorkflowFormulaCalculator } from '../definevalue/define.value.settings';

@Component({
    selector: 'send-pw-reset-mail-settings',
    templateUrl: './send.pw.reset.mail.settings.html'
})
export class SendPWResetMailSettings extends FormulaWorkflowDialogContent {
    static ModuleID = 'sendPWResetMailModule';

    Data = new SendPWResetMailSettingsData();

    public static GetRegistry(): WorkflowRegistry {
        const reg = new WorkflowRegistry();
        reg.ID = SendPWResetMailSettings.ModuleID;
        reg.Caption = '@@SendPasswordResetMail'
        reg.GroupID = 'wfActions';
        reg.Index = 115;
        reg.SettingsControl = SendPWResetMailSettings;
        reg.SettingsTypeHelper = new SendPWResetMailSettingsDataHelper();
        reg.Executer = SendPWResetMailModuleExecuter;
        reg.WorkflowType = WorkflowType.Client;
        return reg;
    }

    initialize(data: any) {
        super.initialize(data);
        if (data) {
            this.Data = ClassTransformerHelper.CopyObject(data, SendPWResetMailSettingsData);
        }
    }

    getResult() {
        return this.Data;
    }
}

export class SendPWResetMailSettingsData {
    MailFormula: string;
}

export class SendPWResetMailSettingsDataHelper extends WorkflowModuleSettingsHelper {
    getExitPoints(settings: any): WorkflowExitInfo[] {
        return [new WorkflowExitInfo()];
    }
    getEmptySettingsInstance() {
        return new SendPWResetMailSettingsData();
    }
}

export class SendPWResetMailModuleExecuter extends WorkflowModuleExecuter {
    async execute(status: WorkflowStatus): Promise<number> {
        return new Promise<number>(resolve => {
            if (status.ActualSettings && status.ActualSettings.MailFormula) {
                const calculator = new WorkflowFormulaCalculator(status);
                const mail = calculator.CalcFormula(status.ActualSettings.MailFormula);
                const mailService = InjectorHelper.InjectorInstance.get<MailSettingsService>(MailSettingsService);
                mailService.SendMailAnonymous({
                    Type: 1,
                    Content: JSON.stringify({
                        NavigationStructure: SideNavService.SelectedNavigationStructure.getValue(),
                        Path: SideNavService.InternalURL.getValue(),
                        MailAddress: mail
                    })
                }).subscribe((x: any) => {
                    if (x) {
                        if (x.Success) {
                            resolve(0);
                        } else {
                            console.error(x.Error);
                            status.Logger.logError('Send pw reset mail modul: Error while sending mail: ' + x.Error);
                            resolve(super.execute(status));
                        }
                    } else {
                        status.Logger.logError('Send pw reset mail modul: Got no result.');
                        resolve(super.execute(status));
                    }
                });
            } else {
                status.Logger.logError('Send pw reset mail modul: No settings found.');
                resolve(super.execute(status));
            }
        });
    }
}